import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feedback-stats-cluster',
  templateUrl: './feedback-stats-cluster.component.html',
  styleUrls: ['./feedback-stats-cluster.component.css']
})
export class FeedbackStatsClusterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
